module.exports = flarum.core.compat['components/PostStream'];